import { render, staticRenderFns } from "./CreateOurServiceDetail.vue?vue&type=template&id=5ffe076a&scoped=true"
import script from "./CreateOurServiceDetail.vue?vue&type=script&lang=js"
export * from "./CreateOurServiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe076a",
  null
  
)

export default component.exports